module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statictics-overview grid"
  }, [_c('div', {
    staticClass: "card statistic-card tracking-chart"
  }, [_c('div', {
    staticClass: "card--top-title"
  }, [_vm._v(_vm._s(_vm.$t('statistics.7days_activity')))]), _vm._v(" "), _c('div', {
    staticClass: "card--content"
  }, [_c('tracking-chart', {
    attrs: {
      "start-date": _vm.startDate,
      "end-date": _vm.endDate,
      "trackings": _vm.trackings
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card--footer"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.actions')) + ": " + _vm._s(_vm.stats.trackings_count) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.average_per_day')) + ": " + _vm._s(_vm.actionsPerDay(_vm.stats.trackings_count)) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card statistic-card kits-stats"
  }, [_c('div', {
    staticClass: "card--top-title"
  }, [_vm._v(_vm._s(_vm.$t('statistics.kits')))]), _vm._v(" "), _c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('p', {
    staticClass: "number--big"
  }, [_vm._v(_vm._s(_vm.stats.trackings_bag_open_count) + "x")]), _vm._v(" "), _c('p', {
    staticClass: "number--subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('statistics.total_businesskit_opened')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card--footer"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.businesskit_sent')) + ": " + _vm._s(_vm.stats.sent_business_kits_count) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card statistic-card coupons-stats"
  }, [_c('div', {
    staticClass: "card--top-title"
  }, [_vm._v(_vm._s(_vm.$t('statistics.coupons')))]), _vm._v(" "), _c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('p', {
    staticClass: "number--big"
  }, [_vm._v(_vm._s(_vm.stats.trackings_view_coupon_count))]), _vm._v(" "), _c('p', {
    staticClass: "number--subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('statistics.coupons_viewed')) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71da9cbb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Specific/StatisticsOverview.vue
// module id = 1943
// module chunks = 0